<template>
  
        <!-- reply -->         
          <div class="column" :style="{backgroundColor: preview ? '' : 'var(--g1)'}" style=" padding: 6px 10px 7px; margin-bottom: 8px; border-left: 0px solid #48BA91; width: fit-content;  border-radius: 10px">
            <div class="row">
              <div class="column" v-if="!preview" style="margin-right: 8px;">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#3755C2"/><path d="M19.75 8C19.8163 8 19.8799 8.02634 19.9268 8.07322C19.9737 8.12011 20 8.1837 20 8.25V13.897C20 14.311 20.336 14.647 20.75 14.647H25.25C25.3163 14.647 25.3799 14.6733 25.4268 14.7202C25.4737 14.7671 25.5 14.8307 25.5 14.897V24.75C25.5 25.4793 25.2103 26.1788 24.6945 26.6945C24.1788 27.2103 23.4793 27.5 22.75 27.5H12.75C12.0207 27.5 11.3212 27.2103 10.8055 26.6945C10.2897 26.1788 10 25.4793 10 24.75V10.75C10 10.0207 10.2897 9.32118 10.8055 8.80546C11.3212 8.28973 12.0207 8 12.75 8H19.75Z" fill="#CFCFCF"/><path d="M21.836 8.38796C21.693 8.27296 21.5 8.38996 21.5 8.57396V12.897C21.5 13.035 21.612 13.147 21.75 13.147H25.048C25.166 13.147 25.24 13.023 25.172 12.927L22.158 8.72996C22.0661 8.60238 21.9578 8.4874 21.836 8.38796Z" fill="#CFCFCF"/></svg>                
              </div>
              <div class="column">
                <img v-if="preview" class=" pointer hover" :src="preview" style="width: 200px; border-radius: 15px; height: auto; margin-bottom: 8px;">  
                <div class="column pointer">
                  <p class="titletext" :title="file.name">{{ tools.cut( file.name, 20) }}</p>
                  <p class="desctext" v-if="file.size">{{ tools.size(file.size) }}</p> 
                  <p class="desctext" v-else>Filesize, kb</p> 
                  <p class="link click" @click="downloadAsFile()">Download</p> 
                </div>
                <!-- {{ file }} -->
              </div>
              <!-- <div class="column">
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9531 15.168H20.709C21.7181 15.168 22.4733 14.9401 22.9746 14.4844C23.4824 14.0221 23.7363 13.4329 23.7363 12.7168C23.7363 11.903 23.4727 11.2389 22.9453 10.7246C22.4245 10.2103 21.7181 9.86849 20.8262 9.69922C20.7025 9.67969 20.6471 9.60156 20.6602 9.46484C20.6862 9.23047 20.7057 8.97982 20.7188 8.71289C20.7318 8.43945 20.7285 8.17578 20.709 7.92188C20.6634 6.96484 20.403 6.08594 19.9277 5.28516C19.459 4.48438 18.8242 3.83984 18.0234 3.35156C17.2292 2.86328 16.3177 2.61914 15.2891 2.61914C14.4818 2.61914 13.7721 2.75586 13.1602 3.0293C12.5547 3.29622 12.0339 3.65755 11.5977 4.11328C11.1615 4.56901 10.7839 5.08008 10.4648 5.64648C10.4128 5.74414 10.3281 5.77669 10.2109 5.74414C9.51432 5.54232 8.84701 5.51628 8.20898 5.66602C7.57096 5.81576 7.05013 6.16081 6.64648 6.70117C6.24935 7.24154 6.0638 8 6.08984 8.97656C6.08984 9.11979 6.02474 9.19141 5.89453 9.19141C4.89193 9.19141 4.10742 9.48112 3.54102 10.0605C2.97461 10.64 2.69141 11.3887 2.69141 12.3066C2.69141 12.834 2.81836 13.3158 3.07227 13.752C3.32617 14.1816 3.69727 14.5267 4.18555 14.7871C4.67383 15.041 5.27279 15.168 5.98242 15.168H10.4551V17.0918H5.99219C4.91146 17.0918 3.97721 16.877 3.18945 16.4473C2.4082 16.0176 1.80599 15.4447 1.38281 14.7285C0.959635 14.0124 0.748047 13.2181 0.748047 12.3457C0.748047 11.5645 0.894531 10.8516 1.1875 10.207C1.48047 9.55599 1.89714 9.01562 2.4375 8.58594C2.97786 8.15625 3.61914 7.87956 4.36133 7.75586C4.38737 7.06576 4.5599 6.44727 4.87891 5.90039C5.19792 5.35352 5.60807 4.90104 6.10938 4.54297C6.61719 4.17839 7.17057 3.93099 7.76953 3.80078C8.36849 3.67057 8.95443 3.67708 9.52734 3.82031C9.9375 3.23438 10.4258 2.70703 10.9922 2.23828C11.5586 1.76302 12.1999 1.38867 12.916 1.11523C13.6387 0.841797 14.4362 0.705078 15.3086 0.705078C16.3307 0.705078 17.2812 0.89388 18.1602 1.27148C19.0391 1.64258 19.8073 2.16992 20.4648 2.85352C21.1289 3.5306 21.6432 4.33138 22.0078 5.25586C22.3789 6.18034 22.5645 7.19596 22.5645 8.30273C23.5345 8.68685 24.2962 9.27604 24.8496 10.0703C25.403 10.8581 25.6797 11.7695 25.6797 12.8047C25.6797 13.625 25.4811 14.3574 25.084 15.002C24.6868 15.6465 24.1204 16.1576 23.3848 16.5352C22.6491 16.9062 21.7734 17.0918 20.7578 17.0918H15.9531V15.168ZM13.209 9.95312C13.4564 9.95312 13.668 10.041 13.8438 10.2168C14.0195 10.3926 14.1074 10.6042 14.1074 10.8516V19.2109L14.0391 20.6562L14.5469 20.041L15.9336 18.5566C16.0964 18.3809 16.3014 18.293 16.5488 18.293C16.7702 18.293 16.959 18.3646 17.1152 18.5078C17.278 18.651 17.3594 18.8398 17.3594 19.0742C17.3594 19.2891 17.2715 19.4779 17.0957 19.6406L13.8828 22.7363C13.7656 22.8535 13.6517 22.9349 13.541 22.9805C13.4368 23.026 13.3262 23.0488 13.209 23.0488C13.0853 23.0488 12.9681 23.026 12.8574 22.9805C12.7467 22.9349 12.6328 22.8535 12.5156 22.7363L9.30273 19.6406C9.13346 19.4779 9.04883 19.2891 9.04883 19.0742C9.04883 18.8398 9.12695 18.651 9.2832 18.5078C9.43945 18.3646 9.62826 18.293 9.84961 18.293C10.097 18.293 10.2988 18.3809 10.4551 18.5566L11.8613 20.041L12.3691 20.666L12.3008 19.2109V10.8516C12.3008 10.6042 12.3887 10.3926 12.5645 10.2168C12.7402 10.041 12.9551 9.95312 13.209 9.95312Z" fill="white"/></svg>
              </div> -->
              
            </div>              
          </div>            
      
</template>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {  
    // console.log('file item', this.id, this.name, this.size, this.raw)    
    // this.downloadAsImage()
  },
  props:{
    // id: Number,
    // name: String, 
    // size: Number,         
    file: {},
  },
  data() {
    return {    
      // image: undefined      
    }
  },
  computed: {
    preview(){
      if (!this.file || !this.file.id) return
      return this.file.preview
    },
  },
  
  methods: {
    async downloadAsImage(){
      // прикрутить кеш картинок
      // https://stackoverflow.com/questions/74579631/displaying-cached-image-via-cache-api
      // console.log("fileitem, download image", this.id)
      if (!this.file || !this.file.id) return
      if (this.type != 'image' && !this.tools.filenameIsImage(this.name)) return      
      let img = await this.api.download.image(this.id)
      let isImage = await this.tools.validImage(img)
      if (isImage){
        this.image = img
      }
      
    },

    async downloadAsFile(){
      // console.log("fileitem, download image", this.id)
      if (!this.file || !this.file.id) return
      let body = await this.api.download.file(this.file.id)
      this.tools.saveFile(`${this.file.name}`, body)
    },
    
    
  },
});

</script>
<style scoped>
.titletext{
  /* color: #48BA91;  */
  line-height: 11px; 
  margin-bottom: 4px;
  color: var(--g8);
  font-weight: 500;
}
.desctext{
  font-size: 11px;
  line-height: 16px;
  color: var(--g4);
}

</style>